"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const FieldsForm_1 = __importDefault(require("../FieldsForm"));
const Styles = common_utils_1.labelStyles(__filename, {
    root: {
        borderRadius: 10,
        border: `1px solid ${design_system_1.Colors.grey300}`,
        padding: '10px 20px 20px 20px',
    },
    legend: {
        padding: '0 10px',
    },
});
const Fields = (props) => (common_utils_1.isolateComponent("fieldset", { css: Styles.root },
    common_utils_1.isolateComponent("legend", { css: Styles.legend }, props.label),
    common_utils_1.isolateComponent(FieldsForm_1.default, Object.assign({}, props.formProps, { fields: props.fields, tag: "div", value: props.value }))));
Fields.defaultProps = {
    value: {},
};
exports.default = Fields;
